<article
    class="storefront-event-card"
    data-testid="upcoming-event-card"
>
    @if (imageUrl(); as imageUrl) {
        <img
            [ngSrc]="imageUrl"
            class="event-card-image"
            width="700"
            height="400"
            [alt]="event().displayName"
        />
    } @else {
        <div
            class="event-card-image-placeholder"
            role="img"
            [attr.aria-label]="event().displayName + ' image unavailable'"
        >
            <i
                class="bi bi-calendar-event"
                aria-hidden="true"
            ></i>
        </div>
    }

    <div class="event-card-body">
        <div>
            <h3 class="h5 fw-bold mb-2">
                {{ event().displayName }}
            </h3>
            @if (description(); as description) {
                <div
                    class="event-card-description quill-flush text-secondary"
                >
                    <quill-view class="d-block" format="html" theme="bubble" [sanitize]="true" [content]="description"></quill-view>
                </div>
            }
        </div>

        <div class="event-card-footer">
            <div class="event-detail-list">
                <div
                    class="event-detail-row"
                    data-testid="event-date"
                >
                    <img
                        ngSrc="assets/calendar_small.svg"
                        class="event-detail-icon"
                        width="20"
                        height="20"
                        alt=""
                        aria-hidden="true"
                    />
                    <span>
                        <span class="visually-hidden">Date: </span>
                        {{ nextDateTime() | date:'EEEE d MMMM' }}
                    </span>
                </div>

                <div
                    class="event-detail-row"
                    data-testid="event-time"
                >
                    <img
                        ngSrc="assets/clock_small.svg"
                        class="event-detail-icon"
                        width="20"
                        height="20"
                        alt=""
                        aria-hidden="true"
                    />
                    <span>
                        <span class="visually-hidden">Time: </span>
                        @if (startDateTime(); as startDateTime) {
                            {{ startDateTime | date:'shortTime' }}
                            @if (endDateTime(); as endDateTime) {
                                @if (startDateTime.getTime() !== endDateTime.getTime()) {
                                    &ndash; {{ endDateTime | date:'shortTime' }}
                                }
                            }
                        } @else {
                            All day
                        }
                    </span>
                </div>

                <div
                    class="event-detail-row align-items-start"
                    data-testid="event-charges"
                >
                    <img
                        ngSrc="assets/deposit_small.svg"
                        class="event-detail-icon"
                        width="20"
                        height="20"
                        alt=""
                        aria-hidden="true"
                    />
                    <div class="vstack gap-1">
                        <span class="visually-hidden">Charges: </span>
                        @if (event().depositAmount; as depositAmount) {
                            <span>
                                {{ null | currencyUnit : depositAmount : currencyCode() }}
                                per person
                            </span>
                        }
                        @if (event().depositFlatFeeAmount; as depositFlatFeeAmount) {
                            <span>
                                {{ null | currencyUnit : depositFlatFeeAmount : currencyCode() }}
                                per booking
                            </span>
                        }
                        @if (event().cancellationChargeAmount; as cancellationChargeAmount) {
                            <span>
                                {{ null | currencyUnit : cancellationChargeAmount : currencyCode() }}
                                cancellation charge per person
                            </span>
                        }
                        @if (event().cancellationChargePartyAmount; as cancellationChargePartyAmount) {
                            <span>
                                {{ null | currencyUnit : cancellationChargePartyAmount : currencyCode() }}
                                cancellation charge per booking
                            </span>
                        }
                        @if (!hasCharges()) {
                            <span>No charges</span>
                        }
                    </div>
                </div>
            </div>

            <button
                type="button"
                class="btn btn-outline-secondary w-100"
                data-testid="learn-more"
                (click)="learnMore.emit()"
            >
                Learn more
            </button>
        </div>
    </div>
</article>
